import React from "react";
import PropTypes from "prop-types";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";

const CardRibbon = ({styleName, title, tipText}) => {

    const tipAndTitle = tipText
        ? <Tooltip title={tipText}>
            <div className={"risk-ribbon-content"}>
                {title}
            </div>
        </Tooltip>
        : <div className={"risk-ribbon-content"}>
            {title}
        </div>

    if (!title) {
        return <></>
    } else {
        return (
            <div className={`risk-ribbon animated fadeIn animation-duration-7 ${styleName}`}>
                {tipAndTitle}
            </div>
        )
    }
};

export default CardRibbon;
CardRibbon.defaultProps = {
    styleName: '',
};

CardRibbon.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    tipText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    extra: PropTypes.node,
    cover: PropTypes.node,
    actions: PropTypes.node
};
